const ETHERSCAN_PREFIXES: { [chainId: number]: string } = {
  1: '',
  3: 'ropsten.',
  4: 'rinkeby.',
  5: 'goerli.',
  42: 'kovan.'
}

export function getEtherscanLink(
  chainId: number,
  data: string,
  type: 'transaction' | 'token' | 'address' | 'block'
): string {
  let prefix: string

  if (chainId === 56 || chainId === 97) {
    const subdomain = chainId === 97 ? 'testnet.' : ''
    prefix = `https://${subdomain}bscscan.com`
  } else if (chainId === 137) {
    prefix = 'https://polygonscan.com'
  } else if (chainId === 42161) {
    prefix = 'https://arbiscan.io'
  } else if (chainId === 1285) {
    prefix = 'https://moonriver.moonscan.io'
  } else {
    prefix = `https://${ETHERSCAN_PREFIXES[chainId] || ETHERSCAN_PREFIXES[1]}etherscan.io`
  }

  switch (type) {
    case 'transaction': {
      return `${prefix}/tx/${data}`
    }
    case 'token': {
      return `${prefix}/token/${data}`
    }
    case 'block': {
      return `${prefix}/block/${data}`
    }
    case 'address':
    default: {
      return `${prefix}/address/${data}`
    }
  }
}
